
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import CircularItem, { CircularItemProps } from './CircularItem';

interface RegulatoryIntelligenceProps {
  circulars: CircularItemProps[];
}

const RegulatoryIntelligence: React.FC<RegulatoryIntelligenceProps> = ({ circulars }) => {
  return (
    <Card>
      <Tabs defaultValue="circulars">
        <CardHeader className="pb-0">
          <div className="flex items-center justify-between">
            <CardTitle>Regulatory Intelligence</CardTitle>
            <TabsList>
              <TabsTrigger value="circulars">Circulars</TabsTrigger>
              <TabsTrigger value="changes">Changes</TabsTrigger>
            </TabsList>
          </div>
          <CardDescription>
            Recent regulatory updates and changes
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-4">
          <TabsContent value="circulars" className="space-y-4">
            {circulars.map((circular) => (
              <CircularItem
                key={circular.id}
                id={circular.id}
                title={circular.title}
                issuer={circular.issuer}
                date={circular.date}
                summary={circular.summary}
              />
            ))}
            <Button variant="outline" className="w-full">View All Circulars</Button>
          </TabsContent>
          <TabsContent value="changes" className="h-[300px] flex items-center justify-center">
            <p className="text-muted-foreground">View all regulatory changes here.</p>
          </TabsContent>
        </CardContent>
      </Tabs>
    </Card>
  );
};

export default RegulatoryIntelligence;
